import { Stack, Typography } from "@mui/material";

export const DisclaimerBlock = ({ text }: { text: string }) => (
  <Stack
    sx={{
      padding: "8px 16px",
      border: "1px solid #FFD5A1",
      borderRadius: "6px",
      backgroundColor: "#FFF7E5",
    }}
  >
    <Typography sx={{ fontSize: "16px", color: "#464646", lineHeight: "24px" }}>
      <span style={{ fontWeight: 600 }}>Disclaimer: </span>
      {text}
    </Typography>
  </Stack>
);
